import React, { Component } from 'react'
import moment from 'moment';
import config from "../../../config";
import { FORMAT_NUMBER, CURRENCY, SYMBOL, Datos_Empresa } from '../../../libs/utils/Const';
import { development } from "../../../libs/utils/Const";

class SalesByDate extends Component {

    render() {
        const { ReportsModel, DocsToPrint } = this.props
        const arrayCheckCashNotes = (DocsToPrint && DocsToPrint[0]) ? DocsToPrint[0].arrayCheckCashNotes : [];
        const arrayCheckRefounds = (DocsToPrint && DocsToPrint[0]) ? DocsToPrint[0].arrayCheckRefounds : [];
        const today = moment(new Date()).format('MM/DD/YYYY');
        const _user = JSON.parse(localStorage.getItem(config.localStorageNamed + 'currentUser'));

        return (
            <>
                <table><tr><td>

                    <div style={{ height: "auto", width: "90%", marginLeft: "auto", marginRight: "auto", marginTop: "2.5vw" }}>
                        <div className="row">
                            <div className="col-3">
                                <img src={development ? require('../../../images/logo_draft.svg') : require('../../../images/logo_EMPRESA.svg')} alt="Logo" />
                                <p className="text-center">{Datos_Empresa.Nombre} {Datos_Empresa.Sociedad}<br /></p>
                            </div>
                            <div className="col-6 text-center">
                                <h5><strong>INFORME DE ARTÍCULOS VENDIDOS POR FECHA</strong></h5>
                            </div>
                            <div className="col-3">
                                <span className="text-left"><strong>Código sucursal:</strong>{_user?.Branch.CodeBranchOffice ?? ''}</span>
                                <p><strong>CÓDIGO ALMACÉN:</strong> {_user?.ProjectCode ?? ''} <br /><strong>FECHA: </strong>{today ?? ''} <br /><strong>USUARIO:</strong>{_user?.U_NAME ?? ''} </p>
                            </div>
                        </div>

                        <div className='row mt-5' style={{ paddingRight: "15px" }}>

                            <div className='col-12'>

                                {ReportsModel.checkCashNotes ?
                                    <>
                                        <h6><strong>Ventas</strong></h6>
                                        {arrayCheckCashNotes && arrayCheckCashNotes.length > 0 &&
                                            arrayCheckCashNotes.map((rowDate) => {
                                                return (
                                                    <>
                                                        <h6><strong>{moment(rowDate.date).format('MM/DD/YYYY') ?? ''}</strong></h6>
                                                        <table>
                                                            <thead>
                                                                <tr style={{ background: "#dee2e6" }}>
                                                                    <th className="text-left">Código</th>
                                                                    <th className="text-left">Descripción</th>
                                                                    <th className="text-left">Cantidad</th>
                                                                    <th className="text-right">Precio</th>
                                                                    {/*<th className="text-right">Precio BSD</th>*/}
                                                                    {/*<th className="text-center">% Descuento</th>*/}
                                                                    <th className="text-right">Impuesto</th>
                                                                    {/* <th className="text-right">Importe NSD</th> */}
                                                                    {/* <th className="text-right">Importe NCD</th> */}
                                                                    {/* <th className="text-center">Desc. Partida</th> */}
                                                                    <th className="text-right">Impuestos</th>
                                                                </tr>
                                                            </thead>
                                                            {rowDate && rowDate.lines.length > 0 &&
                                                                rowDate.lines.map((itemSold) => {
                                                                    return (
                                                                        <tbody >
                                                                            <tr style={{ fontSize: '12px', borderBottom: "solid 1px" }}>
                                                                                <td className="text-left">{itemSold.ItemCode ?? ''}</td>
                                                                                <td className="text-left">{itemSold.Dscription ?? ''}</td>
                                                                                <td className="text-left">{Number(itemSold.Quantity).toFixed(2) ?? ''}</td>
                                                                                <td className="text-right">{CURRENCY + ' ' + FORMAT_NUMBER.new(Number(itemSold.Price).toFixed(2)) ?? ''}</td>
                                                                                {/*<td className="text-right">{SYMBOL + FORMAT_NUMBER.new(Number(itemSold.AvgPrice).toFixed(2)) + CURRENCY ?? ''}</td>*/}
                                                                                {/*<td className="text-center">{Number(itemSold.DiscPrcnt1 || 0).toFixed(2) ?? ''} %</td>*/}
                                                                                <td className="text-right">{CURRENCY + ' ' + FORMAT_NUMBER.new(itemSold.PriceBCD) ?? ''}</td>
                                                                                {/* <td className="text-right">$296.00</td> */}
                                                                                {/* <td className="text-right">$296.00</td> */}
                                                                                {/* <td className="text-center">{Number(itemSold.DiscPrcnt1).toFixed(2) ?? ''} % </td> */}
                                                                                <td className="text-right">{CURRENCY + ' ' + FORMAT_NUMBER.new(itemSold.VatSum) ?? ''}</td>
                                                                            </tr>
                                                                        </tbody>
                                                                    )
                                                                })
                                                            }
                                                        </table>
                                                    </>
                                                )

                                            })

                                        }

                                    </>
                                    :
                                    <>

                                    </>

                                }

                                {ReportsModel.checkRefounds ?
                                    <>
                                        <h6><strong>Devoluciones</strong></h6>
                                        {arrayCheckRefounds && arrayCheckRefounds.length > 0 &&
                                            arrayCheckRefounds.map((rowDate) => {
                                                return (
                                                    <>
                                                        <h6><strong>{moment(rowDate.date).format('MM/DD/YYYY') ?? ''}</strong></h6>
                                                        <table>
                                                            <thead>
                                                                <tr style={{ background: "#dee2e6" }}>
                                                                    <th className="text-left">Código</th>
                                                                    <th className="text-left">Descripción</th>
                                                                    <th className="text-left">Cantidad</th>
                                                                    <th className="text-right">Precio</th>
                                                                    <th className="text-right">Precio BSD</th>
                                                                    <th className="text-center">% Descuento</th>
                                                                    <th className="text-right">Precio BCD</th>
                                                                    {/* <th className="text-right">Importe NSD</th> */}
                                                                    {/* <th className="text-right">Importe NCD</th> */}
                                                                    {/* <th className="text-center">Desc. Partida</th> */}
                                                                    <th className="text-right">Impuestos</th>
                                                                </tr>
                                                            </thead>
                                                            {rowDate && rowDate.lines.length > 0 &&
                                                                rowDate.lines.map((itemSold) => {
                                                                    return (
                                                                        <tbody >
                                                                            <tr style={{ fontSize: '12px', borderBottom: "solid 1px" }}>
                                                                                <td className="text-left">{itemSold.ItemCode ?? ''}</td>
                                                                                <td className="text-left">{itemSold.Dscription ?? ''}</td>
                                                                                <td className="text-left">{Number(itemSold.Quantity).toFixed(2) ?? ''}</td>
                                                                                <td className="text-right">{CURRENCY + ' ' + (FORMAT_NUMBER.new(Number(itemSold.Price).toFixed(2)) ?? '')}</td>
                                                                                <td className="text-right">{CURRENCY + ' ' + (FORMAT_NUMBER.new(Number(itemSold.AvgPrice).toFixed(2)) ?? '')}</td>
                                                                                <td className="text-center">{Number(itemSold.DiscPrcnt1 || 0).toFixed(2) ?? ''} %</td>
                                                                                <td className="text-right">{CURRENCY + ' ' + (FORMAT_NUMBER.new(itemSold.PriceBCD) ?? '')}</td>
                                                                                {/* <td className="text-right">$296.00</td> */}
                                                                                {/* <td className="text-right">$296.00</td> */}
                                                                                {/* <td className="text-center">{Number(itemSold.DiscPrcnt1).toFixed(2) ?? ''} % </td> */}
                                                                                <td className="text-right">{CURRENCY + ' ' + (FORMAT_NUMBER.new(itemSold.VatSum) ?? '')}</td>
                                                                            </tr>
                                                                        </tbody>
                                                                    )
                                                                })
                                                            }
                                                        </table>
                                                    </>
                                                )

                                            })

                                        }

                                    </>
                                    :
                                    <>

                                    </>

                                }


                            </div>
                        </div>

                    </div>

                </td></tr></table>
            </>
        )
    }
}

export default SalesByDate